module.exports = __webpack_public_path__ + "static/img/807.1dd62bc2.png";